"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { useAuthFlow } from "@/components/auth/auth-flow-context";
import { PhoneAuthStep, usePhoneAuth } from "@/components/auth/methods/phone/phone-auth-context";
import { usePhoneCodeCooldown } from "@/components/auth/methods/phone/use-phone-code-cooldown";
import { AuthMethodId } from "@/components/auth/types";
import { Button, Input } from "@/components/ui";
import { Label } from "@/components/ui/label";
import PhoneNumberInput from "@/components/ui/phone-number-input";
import { cx } from "@/lib/tailwind-utils";
import { useSignUpAuth } from "./sign-up-auth";
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const MIN_PASSWORD_LENGTH = 6;
type Props = {
  className?: string;
};
export function EmailPasswordPhoneEntry(t0) {
  const $ = _c(35);
  const {
    className
  } = t0;
  const {
    state
  } = usePhoneAuth();
  const phoneError = useAuthFlow().state.errors[AuthMethodId.PHONE];
  const {
    email,
    setEmail,
    password,
    setPassword,
    submitEntry,
    googleEntry
  } = useSignUpAuth();
  const isGoogle = googleEntry !== null;
  const [phoneNumber, setPhoneNumber] = useState(state.phoneNumber);
  const {
    isCoolingDown,
    secondsRemaining,
    startCooldown
  } = usePhoneCodeCooldown();
  if (state.step !== PhoneAuthStep.ENTER_PHONE) {
    return null;
  }
  let t1;
  if ($[0] !== phoneNumber) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = /\D/g;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = phoneNumber.replace(t2, "");
    $[0] = phoneNumber;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const phoneValid = t1.length === 10;
  let t2;
  if ($[3] !== email) {
    t2 = EMAIL_RE.test(email.trim());
    $[3] = email;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const emailValid = t2;
  const passwordValid = password.length >= MIN_PASSWORD_LENGTH;
  const isFormValid = isGoogle ? phoneValid : phoneValid && emailValid && passwordValid;
  let t3;
  if ($[5] !== isCoolingDown || $[6] !== isFormValid || $[7] !== phoneNumber || $[8] !== startCooldown || $[9] !== submitEntry) {
    t3 = async e => {
      e.preventDefault();
      if (!isFormValid || isCoolingDown) {
        return;
      }
      startCooldown();
      await submitEntry(phoneNumber);
    };
    $[5] = isCoolingDown;
    $[6] = isFormValid;
    $[7] = phoneNumber;
    $[8] = startCooldown;
    $[9] = submitEntry;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const handleSubmit = t3;
  let t4;
  if ($[11] !== className) {
    t4 = cx("w-full space-y-4", className);
    $[11] = className;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== email || $[14] !== isGoogle || $[15] !== password || $[16] !== setEmail || $[17] !== setPassword) {
    t5 = !isGoogle && <><div className="space-y-1"><Label htmlFor="email" mandatory={true}>Email</Label><Input id="email" type="email" placeholder="Email" value={email} autoComplete="email" onChange={e_0 => setEmail(e_0.target.value)} /></div><div className="space-y-1"><Label htmlFor="password" mandatory={true}>Password</Label><Input id="password" type="password" placeholder="At least 6 characters" value={password} autoComplete="new-password" onChange={e_1 => setPassword(e_1.target.value)} /></div></>;
    $[13] = email;
    $[14] = isGoogle;
    $[15] = password;
    $[16] = setEmail;
    $[17] = setPassword;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Label htmlFor="phoneNumber" mandatory={true}>Phone Number</Label>;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = e_2 => setPhoneNumber(e_2.target.value);
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  const t8 = !!phoneError;
  let t9;
  if ($[21] !== phoneError || $[22] !== phoneNumber || $[23] !== t8) {
    t9 = <div className="space-y-1">{t6}<PhoneNumberInput id="phoneNumber" placeholder="Phone Number" value={phoneNumber} onChange={t7} hasError={t8} errorMessage={phoneError} /></div>;
    $[21] = phoneError;
    $[22] = phoneNumber;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const t10 = !isFormValid || state.isSendingCode || isCoolingDown;
  const t11 = isCoolingDown ? `Try again in ${secondsRemaining}s` : "Send Verification Code";
  let t12;
  if ($[25] !== state.isSendingCode || $[26] !== t10 || $[27] !== t11) {
    t12 = <Button variant="primary" type="submit" className="w-full" disabled={t10} isLoading={state.isSendingCode} loadingText="Sending...">{t11}</Button>;
    $[25] = state.isSendingCode;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== handleSubmit || $[30] !== t12 || $[31] !== t4 || $[32] !== t5 || $[33] !== t9) {
    t13 = <form onSubmit={handleSubmit} className={t4}>{t5}{t9}{t12}</form>;
    $[29] = handleSubmit;
    $[30] = t12;
    $[31] = t4;
    $[32] = t5;
    $[33] = t9;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  return t13;
}